"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pulse_components_1 = require("@pcs/pulse-components");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const material_1 = require("@mui/material");
const utilities_1 = __importDefault(require("jsAssets/utilities"));
const helpers_1 = require("../../../../asset-detail/helpers");
const assetDetailSlice_1 = require("../../../../asset-detail/store/assetDetailSlice");
const commentSlice_1 = require("../../../../asset-detail/store/commentSlice");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const CommentEmailHistoryModal_1 = __importDefault(require("./CommentEmailHistoryModal"));
const helper_1 = require("../../../helper");
const AssetComment = (props) => {
    var _a;
    const { comment, handleOpenCommentReply, jobId, asset } = props;
    const { reviewRound } = (0, react_redux_1.useSelector)((state) => state.review);
    const [text, setText] = (0, react_1.useState)('');
    const [selectedFolder, setSelectedFolder] = (0, react_1.useState)({
        label: asset === null || asset === void 0 ? void 0 : asset.dirName,
        value: asset === null || asset === void 0 ? void 0 : asset.dirId,
    });
    const [childFiles, setChildFiles] = (0, react_1.useState)([]);
    const dispatch = (0, react_redux_1.useDispatch)();
    const [openModal, setOpenModal] = (0, react_1.useState)(false);
    const [userEmails, setUserEmails] = (0, react_1.useState)([]);
    const onOpenModal = () => {
        setOpenModal(!openModal);
    };
    const onChangeEditor = (value) => {
        setText(value);
    };
    const handleOpenEditor = (id) => {
        handleOpenCommentReply(id);
    };
    const handleDeleteComment = (id) => {
        const messages = {
            loading: 'Deleting comment',
            success: 'Your comment has been deleted',
            fail: 'Unable to delete comment',
        };
        const payload = {
            action: 'comments',
            type: 'delete',
            jobId,
            noteId: id,
        };
        (0, helpers_1.handleRequestAPI)(messages, payload, () => {
            dispatch((0, commentSlice_1.deleteVersionComments)(id));
            dispatch((0, assetDetailSlice_1.fetchAssetDetail)({
                assetId: asset === null || asset === void 0 ? void 0 : asset.assetId,
            }));
        });
    };
    const openViewProof = () => {
        window.open(`${helper_1.URLS.app}reviews/view-proof/${(reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.id) || (reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.roundId)}`, '_blank');
    };
    const OpenCommentButton = () => {
        return (react_1.default.createElement(pulse_components_1.PulseTooltip, { TippyProps: {
                content: 'View Proof',
                placement: 'top',
                popperOptions: {
                    strategy: 'fixed',
                },
                className: styles_modules_less_1.default['ziflow-activity__open-btn'],
            } },
            react_1.default.createElement(pulse_components_1.PulseButtonV3, { variant: pulse_components_1.V3ButtonVariant.tertiary, icon: true, label: 'View Proof', iconClasses: {
                    icon: 'fal fa-external-link',
                }, onClick: openViewProof })));
    };
    const resetReply = () => {
        setText('');
    };
    const addChildFiles = (acceptedFiles) => {
        setChildFiles([...childFiles, ...acceptedFiles]);
    };
    const removeChildFile = (removedFile) => {
        const updatedFiles = childFiles.filter((file) => {
            return removedFile.name !== file.name;
        });
        setChildFiles(updatedFiles);
    };
    const renameChildFile = (renamedFiles) => {
        setChildFiles([...renamedFiles]);
    };
    const onOpenEmailHistory = async (noteid) => {
        const response = await pulse_components_1.v2Endpoint.get(window.pulse.config.urls.api, {
            params: {
                action: 'files',
                type: 'emailHistory',
                noteId: noteid,
            },
        });
        if (response.data.success) {
            setUserEmails([...response.data.data]);
            setOpenModal(!openModal);
        }
    };
    const handleCallback = async () => {
        var _a;
        const selectedJobId = (_a = asset === null || asset === void 0 ? void 0 : asset.job) === null || _a === void 0 ? void 0 : _a.jobId;
        const assetIds = [];
        const dirId = selectedFolder || (asset === null || asset === void 0 ? void 0 : asset.dirId);
        if (childFiles.length) {
            await Promise.all(childFiles.map(async (file) => {
                const uploaded = await (0, helpers_1.handleUploadAttachment)(file, selectedJobId, dirId.value);
                if (uploaded) {
                    assetIds.push(uploaded.latestAssetId);
                }
            }));
        }
        const payload = {
            action: 'comments',
            type: 'save',
            jobId,
            linkedAssetIds: assetIds,
            assetId: asset === null || asset === void 0 ? void 0 : asset.assetId,
            dirId: selectedFolder || (asset === null || asset === void 0 ? void 0 : asset.dirId),
            parentnoteid: comment.noteId,
            comment: text,
        };
        if (!text && assetIds.length) {
            payload.comment = 'Attachment';
        }
        const messages = {
            loading: 'Saving comment...',
            success: 'Saved comment...',
            fail: 'Unable to save comment',
        };
        if (payload.comment) {
            (0, helpers_1.handleRequestAPI)(messages, payload, (newNotes) => {
                handleOpenEditor();
                dispatch((0, commentSlice_1.fetchAssetComments)({ assetId: asset === null || asset === void 0 ? void 0 : asset.assetId }));
                resetReply();
                const { noteId } = newNotes[0];
                $.ajax({
                    type: 'POST',
                    url: `${helper_1.URLS.pulse}v2/ajax/comment/${jobId}/notify`,
                    data: { ...payload, noteId },
                });
            });
        }
        else {
            utilities_1.default === null || utilities_1.default === void 0 ? void 0 : utilities_1.default.notification.danger('You have no notes and have not attached any assets. Please add some text to your comment or attach some assets first.');
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(pulse_components_1.PulseComment, { data: comment, classes: {
                avatar: styles_modules_less_1.default['comment__root--avatar'],
                root: styles_modules_less_1.default.comment__root,
                replyBtn: styles_modules_less_1.default['comment__reply-btn'],
                secondaryAction: comment.type === 'review-activity-history' &&
                    styles_modules_less_1.default['comment__secondary-action'],
                commentContentRoot: styles_modules_less_1.default['comment__content--root'],
                commentContentContainer: styles_modules_less_1.default['comment__content--container'],
                commentContentHeader: styles_modules_less_1.default['comment__content--header'],
            }, childCommentProps: {
                classes: {
                    avatar: styles_modules_less_1.default['child-comment--avatar'],
                    root: styles_modules_less_1.default['child-comment--root'],
                    commentContentContainer: styles_modules_less_1.default['child-comment__content--container'],
                    commentContentHeader: styles_modules_less_1.default['child-comment__content--header'],
                },
            }, allowReply: comment.type !== 'review-activity-history', showReply: !!(comment === null || comment === void 0 ? void 0 : comment.isReply), onDelete: handleDeleteComment, onOpenMailHistory: onOpenEmailHistory, PulseAvatarProps: {
                classes: {
                    root: styles_modules_less_1.default['comment--avatar'],
                },
            }, secondaryActionComponent: comment.type === 'review-activity-history' ? (react_1.default.createElement(OpenCommentButton, null)) : (react_1.default.createElement(react_1.default.Fragment, null)), onReplyClick: () => {
                handleOpenEditor(comment.noteId);
            }, PulseEditorProps: {
                footer: true,
                onEditorChange: onChangeEditor,
                value: text,
                PulseUploaderProps: {
                    PulseButtonBaseProps: {
                        classes: [styles_modules_less_1.default['add-attachment--btn']],
                    },
                    allowSelectFolder: true,
                    visible: true,
                    files: childFiles,
                    onFileDrop: addChildFiles,
                    onFileRemove: removeChildFile,
                    onFileRename: renameChildFile,
                    PulseFolderSelectProps: {
                        jobId: (_a = asset === null || asset === void 0 ? void 0 : asset.job) === null || _a === void 0 ? void 0 : _a.jobId,
                        value: selectedFolder,
                        valueChangeHandler: (changedFolder) => {
                            setSelectedFolder({ ...changedFolder.dirId });
                        },
                        isClearable: false,
                    },
                },
                onCancel: () => {
                    handleOpenEditor(comment.noteId);
                },
                onSave: handleCallback,
            } }),
        react_1.default.createElement(material_1.Divider, { variant: "middle", className: styles_modules_less_1.default['comment--divider'] }),
        react_1.default.createElement(CommentEmailHistoryModal_1.default, { isOpen: openModal, handleOpenModal: onOpenModal, userEmails: userEmails })));
};
exports.default = AssetComment;
